import { PostMessageReply, PostMessage } from '../Shared/PostMessage';

export const GetMeetingIdMessageType = 'MeetingInfo_GetMeetingId';
export const SetMeetingIdMessageType = 'MeetingInfo_SetMeetingId';
export const GetSeriesIdMessageType = 'MeetingInfo_GetSeriesId';
export const SetSeriesIdMessageType = 'MeetingInfo_SetSeriesId';

export interface GetMeetingIdMessage extends PostMessage<typeof GetMeetingIdMessageType> {}
export interface GetSeriesIdMessage extends PostMessage<typeof GetSeriesIdMessageType> {}

export interface GetMeetingIdReplyMessage extends PostMessageReply {
  payload: string;
}

export interface SetMeetingIdMessage extends PostMessage<typeof SetMeetingIdMessageType> {
  payload: { meetingId: string };
}

export interface GetSeriesIdReplyMessage extends PostMessageReply {
  payload: string;
}

export interface SetSeriesIdMessage extends PostMessage<typeof SetSeriesIdMessageType> {
  payload: { seriesId: string };
}
